<template>
  <div>
    <el-table-column
      :min-width="minWidth"
      :label="$t('common_words.operations')"
      fixed="right"
    >
      <template slot-scope="props">
        <div class="text-center spacing-operations">
          <slot name="append" :dataProps="props"></slot>
          <a
            v-if="
              (props.row.show === undefined && canShow && isShow()) ||
              (props.row.show && canShow && isShow())
            "
            v-show="!isCurrentlyViewing(props.row)"
            v-tooltip.top-center="$t('common_words.view')"
            class="btn-info btn-simple btn-link custom-margin-actions"
            @click="handleView(props.$index, props.row)"
          >
            <em class="fa fa-eye custom-size-fa-actions"></em>
          </a>
          <a
            v-if="
              !checkHowMuchTimePassed(props.row) &&
              showOperationEdit &&
              isUpdate() &&
              enabledEdit(props)
            "
            v-tooltip.top-center="
              props.row.deleted_at && canDisable ? '' : $t('common_words.edit')
            "
            :class="`btn-${
              props.row.deleted_at && canDisable ? `primary` : `warning`
            } btn-simple btn-link custom-margin-actions`"
            @click="
              props.row.deleted_at && canDisable
                ? ''
                : handleEdit(props.$index, props.row)
            "
          >
            <em class="fa fa-edit custom-size-fa-actions"></em>
          </a>
          <a
            v-if="canDelete && isDelete() && isClosing(props.row)"
            v-tooltip.top-center="getTextTooltipDelete(props.row)"
            :class="`btn-${
              props.row.deleted_at && canDisable ? `info` : `danger`
            } btn-simple btn-link custom-margin-actions`"
            @click="
              props.row.deleted_at && canDisable
                ? handleActivate(props.$index, props.row)
                : handleDelete(props.$index, props.row)
            "
          >
            <em
              :class="`fa ${
                props.row.deleted_at && canDisable
                  ? `fa-check-circle`
                  : `fa-times`
              } custom-size-fa-actions`"
            ></em>
          </a>
          <a
            v-if="props.row.created_user || props.row.updated_user"
            class="custom-margin-actions"
            style="margin-top: -4px"
          >
            <user-operation-info
              style="font-size: 16px !important"
              :createdUser="props.row.created_user"
              :updatedUser="props.row.updated_user"
            />
          </a>
          <slot name="end"></slot>
        </div>
      </template>
    </el-table-column>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from '../../i18n';
import moment from 'moment';
import UserOperationInfo from 'src/components/UserOperationInfo.vue';

export default {
  name: 'table-columns-operations',
  mixins: [MixinPermissions],
  components: {
    UserOperationInfo,
  },
  props: {
    canShow: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    showOperationEdit: {
      type: Boolean,
      default: true,
    },
    canDisable: {
      type: Boolean,
      default: false,
    },
    howMuchTimePassed: {
      type: Array,
      default: () => [],
    },
    minWidth: {
      type: Number,
      default: 0,
    },
    extraValidateEdit: {
      type: Object | null,
      default: null,
    },
    viewingRecordId: {
      type: [Number, String, null],
      default: null,
    },
  },
  methods: {
    isCurrentlyViewing(row) {
      return this.viewingRecordId !== null && row.id === this.viewingRecordId;
    },

    enabledEdit(scope) {
      if (this.extraValidateEdit) {
        return eval(
          `scope.${this.extraValidateEdit.targetToValidate} 
          ${this.extraValidateEdit.operationToValidate} 
          '${this.extraValidateEdit.valueToValidate}'`
        );
      } else return true;
    },

    isClosing(row) {
      if (row.closing) {
        if (Number(row.closing) === 0) return true;
        else return false;
      }

      return true;
    },

    checkHowMuchTimePassed(row) {
      if (this.howMuchTimePassed.length === 3) {
        const today = moment();
        const oneMonthAgo = moment(row[this.howMuchTimePassed[0]]).add(
          this.howMuchTimePassed[1],
          this.howMuchTimePassed[2]
        );

        return today.isAfter(oneMonthAgo);
      }

      return false;
    },

    handleView(index, row) {
      this.$emit('handleView', index, row);
    },
    handleEdit(index, row) {
      this.$emit('handleEdit', index, row);
    },
    handleDelete(index, row) {
      this.$emit('handleDelete', index, row);
    },
    handleActivate(index, row) {
      this.$emit('handleActivate', index, row);
    },
    getTextTooltipDelete(row) {
      if (row.deleted_at && this.canDisable)
        return i18n.t('common_words.activate');
      else if (!this.canDisable) return i18n.t('common_words.erase');
      else return i18n.t('common_words.disable');
    },
  },
};
</script>
<style>
.spacing-operations {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.spacing-operations > a {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
